(() => {
  const root = document.querySelector('[data-group-root]');
  if (!root) return;
  const choices = [...root.querySelectorAll('[data-group-choice]')];
  const panels = [...root.querySelectorAll('.group-panel')];
  function select(choice, focus = true) {
    choices.forEach(button => button.setAttribute('aria-expanded', String(button.dataset.groupChoice === choice)));
    panels.forEach(panel => {panel.hidden = panel.id !== `group-${choice}`;});
    const panel = panels.find(panel => !panel.hidden);
    if (focus && panel) {panel.focus({preventScroll:true}); panel.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start'});}
  }
  choices.forEach(button => button.addEventListener('click', () => select(button.dataset.groupChoice)));
  root.querySelectorAll('[data-group-reset]').forEach(button => button.addEventListener('click', () => {const active = choices.find(button => button.getAttribute('aria-expanded') === 'true'); select(null); active?.focus();}));
  const phone = (root.dataset.whatsapp || '').replace(/\D/g, '');
  const ready = phone.length >= 8 && phone.length <= 15;
  if (ready) {
    root.querySelector('[data-model-submit]').textContent = 'WhatsApp’tan paylaşın';
    root.querySelector('[data-group-form="appointment"] .group-submit').textContent = 'WhatsApp’tan randevu isteyin';
  }
  else root.querySelector('[data-photo-help]').textContent = 'Modelinizin bağlantısını veya açıklamasını not alanına yazabilirsiniz. Fotoğraf paylaşımı mağazanın WhatsApp iletişimi bağlandığında açılacak. Bu talep sipariş veya ödeme oluşturmaz.';
  const today = new Date();
  const date = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`;
  root.querySelector('[data-appointment-date]').min = date;
  root.querySelectorAll('form').forEach(form => {
    form.addEventListener('submit', event => {
      const type = form.dataset.groupForm;
      const status = form.querySelector('[data-group-status]');
      if (ready) {
        event.preventDefault();
        const fields = [...new FormData(form)].filter(([key]) => key.startsWith('contact['));
        const message = ['SAWAS — ' + (type === 'model' ? 'Grup takım talebi' : 'Mağaza randevu talebi'), ...fields.map(([key,value]) => `${key.slice(8,-1)}: ${value}`)].join('\n');
        location.href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
        status.textContent = type === 'model' ? 'WhatsApp’ta mesajınızı ve model fotoğrafınızı göndererek talebinizi tamamlayın.' : 'WhatsApp’ta mesajı gönderin. Randevunuz mağaza onayından sonra kesinleşir.';
      } else {
        event.preventDefault();
        status.textContent = 'WhatsApp iletişim bağlantısı henüz hazır değil; talebiniz gönderilmedi.';
      }
    });
    const result = form.querySelector('[data-contact-result]');
    if (result && result.textContent.trim()) select(form.dataset.groupForm, false);
  });
  const initial = new URLSearchParams(location.search).get('secim');
  const params = new URLSearchParams(location.search);
  const color = params.get('renk');
  const model = params.get('model');
  if (['Siyah','Lacivert','Bebe mavisi','Krem','Haki','Kahverengi'].includes(color)) {
    const field = root.querySelector('[name="contact[Renk]"]');
    if (field) field.value = color;
    const note = root.querySelector('[data-group-form="model"] [name="contact[body]"]');
    if (note && model === 'Kruvaze') note.value = 'Kruvaze takım hakkında bilgi almak istiyorum.';
  }
  if (['model', 'appointment'].includes(initial)) select(initial, false);
})();
